<template>
  <div class="items-center bg-wrp main-wrp">
    <div class="container wrapper-for-adaptive">
      <section class="hero">
        <div class="head">
          <div class="title">
            <div />
            <h1 id="hero-head-title">
              Design stunning visuals in less than 18 minutes
            </h1>
            <div class="sub-title">
              DreamFlat - easy to use interior design app
            </div>
            <div class="goahead">
              <div class="goahead-item">
                <DownloadLauncherButton
                  icon="img:windows-icon.svg"
                  :add-version-to-label="false"
                >
                  <iconWindows />
                </DownloadLauncherButton>
              </div>
              <div
                class="goahead-btn"
                style="padding: 0 20px 0 17px"
                @click="startVideo('promo')"
              >
                <iconPlay />
                Watch Video Guide
              </div>
            </div>
          </div>
          <div
            class="head-img-container"
            @click="startVideo('promo')"
          >
            <video
              class="head-img"
              no-controls
              autoplay
              loop
              playsinline
              muted
            >
              <source
                :src="`${staticUrl}/video/intro_800x648.mp4`"
                type="video/mp4"
              />
            </video>
          </div>
          <div class="mobile-background-radial-image-block">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1338"
              height="510"
              viewBox="0 0 428 437"
              fill="none"
            >
              <path
                d="M101.252 329.621C-39.3359 332.506 -228.214 414.085 -265 435L-124.299 -75L995.668 -61.3249L1073 294.763C1005.07 315.946 881.55 395.047 648.75 376.009C494.023 363.356 218.86 327.208 101.252 329.621Z"
                fill="#F6F7FA"
                stroke="#F4F6FD"
              />
            </svg>
          </div>
        </div>
        <div class="start-info-wrp">
          <div class="cards-head">
            <div class="item custom-width">
              <h3 class="title">Simple</h3>
              <p class="text">
                Friendly interface for simple navigation
              </p>
            </div>
            <div class="item custom-width">
              <h3 class="title">90 seconds</h3>
              <p class="text">To start first project</p>
            </div>
            <div class="item">
              <h3 class="title">Unreal Engine 5</h3>
              <p class="text">To reduce render time</p>
            </div>
          </div>
        </div>
        <div class="m-btn">
          <div class="download-app-on-mobile">
            <DownloadLauncherButton
              icon="img:windows-icon.svg"
              :add-version-to-label="false"
            >
              <iconWindows />
            </DownloadLauncherButton>
          </div>
          <div
            class="goahead-btn"
            style="padding: 0 20px 0 17px"
            @click="startVideo('promo')"
          >
            <iconPlay />
            Watch Video Guide
          </div>
        </div>
      </section>
      <section class="make-aesthetic-section">
        <div class="make-aesthetic-title-block">
          <div class="make-aesthetic-title-block__title">
            Make Aesthetic Visuals
            <span class="mobile-indent" /><br /><span
              class="title_blue"
              >In 18 Minutes</span
            >
          </div>
          <div class="make-aesthetic-title-block__subtitle">
            Create your dream design from the scratch in one evening
          </div>
        </div>
        <div class="make-aesthetic-cards-block">
          <div
            class="make-aesthetic-cards-block__card make-aesthetic-cards-block__card_with-gap"
          >
            <img
              :src="`${staticUrl}/images/nmp-1.webp`"
              alt=""
              class="ma-card-image"
            />
            <div class="ma-card-title">
              Layout
              <div class="ma-card-title-time">3 mins</div>
            </div>
            <div class="ma-card-subtitle">
              Upload the layout of your space
            </div>
          </div>
          <div class="make-aesthetic-cards-block__card">
            <img
              :src="`${staticUrl}/images/nmp-2.webp`"
              alt=""
              class="ma-card-image"
            />
            <div class="ma-card-title">
              Design
              <div class="ma-card-title-time">12 mins</div>
            </div>
            <div class="ma-card-subtitle">
              Customize every detail of the space
            </div>
          </div>
          <div
            class="make-aesthetic-cards-block__card make-aesthetic-cards-block__card_with-gap"
          >
            <img
              :src="`${staticUrl}/images/nmp-3.webp`"
              alt=""
              class="ma-card-image"
            />
            <div class="ma-card-title">
              Renders
              <div class="ma-card-title-time">from 5 sec</div>
            </div>
            <div class="ma-card-subtitle">
              Visualize your project in real time
            </div>
          </div>
        </div>
      </section>
      <section class="landing-try">
        <div class="info-section">
          <img
            class="landing-try-image"
            :src="`${staticUrl}/images/mp-laptop.webp`"
          />
          <div class="info try-info">
            <div class="title">
              It's Real Fast.
              <br />
              Check It Out.
            </div>
            <p class="text">
              Bring your ideas to life with lifelike rendering and
              experience design like never before.
            </p>
            <img
              class="m-img"
              :src="`${staticUrl}/images/mp-laptop.webp`"
            />
            <div class="m-btn">
              <p class="m-btn-text">
                {{ $t('Already available for Windows') }}
              </p>
              <div
                class="goahead-btn"
                style="padding: 0 20px 0 17px"
                @click="startVideo('promo')"
              >
                <iconPlay />
                Watch Video Guide
              </div>
            </div>
            <div class="goahead flex">
              <div class="goahead-item">
                <!--                <div class="goahead-item-after">-->
                <!--                  {{ $t('Its free!') }}-->
                <!--                </div>-->
                <DownloadLauncherButton
                  icon="img:windows-icon.svg"
                  :add-version-to-label="false"
                >
                  <iconWindows />
                </DownloadLauncherButton>
              </div>
              <div
                class="goahead-btn"
                style="padding: 0 20px 0 17px"
                @click="startVideo('promo')"
              >
                <iconPlay />
                Watch Video Guide
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="switcher-box">
        <div class="switcher-box__title">
          See Your Vision Come to Life
        </div>
        <div class="switcher">
          <div class="switcher-chose-box">
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 1,
              }"
              @click="featuresCounter = 1"
            >
              <div class="el-number">1</div>
              <div class="el-info">
                <div class="el-title">Renders</div>
                <!--              <div class="el-text">{{ $t('Static renderers are an integral part of the visualization of any project. DreamFlat allows you to shoot photorealistic renderings in just a few seconds!') }}</div>-->
              </div>
            </div>
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 2,
              }"
              @click="featuresCounter = 2"
            >
              <div class="el-number">2</div>
              <div class="el-info">
                <div class="el-title">Video fly-throughs</div>
                <!--              <div class="el-text">{{ $t('Video clips complement the renderings, presenting the apartment on any device from several angles. All you need to create a video flight through the interior is to adjust the viewing angle and speed of the camera.') }}</div>-->
              </div>
            </div>
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 3,
              }"
              @click="featuresCounter = 3"
            >
              <div class="el-number">3</div>
              <div class="el-info">
                <div class="el-title">3D-Tours for websites</div>
                <!--              <div class="el-text">{{ $t('3D-tours are a tool that makes it possible to virtually study the layout of an apartment and present the interior from all sides.') }}</div>-->
              </div>
            </div>
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 4,
              }"
              @click="featuresCounter = 4"
            >
              <div class="el-number">4</div>
              <div class="el-info">
                <div class="el-title">Interactive tours</div>
                <!--              <div class="el-text">{{ $t('You can move around the apartment right in front of the client — using a keyboard or a computer mouse.') }}</div>-->
              </div>
            </div>
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 5,
              }"
              @click="featuresCounter = 5"
            >
              <div class="el-number">5</div>
              <div class="el-info">
                <div class="el-title">VR</div>
                <!--              <div class="el-text">{{ $t('The DreamFlat VR mode allows you to move into an apartment and, as if live, feel its dimensions, the size of windows and the height of ceilings. And high quality graphics will give you the opportunity to evaluate the details of interior design.') }}</div>-->
              </div>
            </div>
          </div>

          <div class="switcher-info-box">
            <transition name="switcher-animation" mode="out-in">
              <div
                v-if="featuresCounter === 1"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">Renders</div>
                  <div class="info-container__text">
                    Static renderers are an integral part of the
                    visualization of any project. DreamFlat allows you
                    to shoot photorealistic renderings in just a few
                    seconds!
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container__image">
                    <img
                      :src="`${staticUrl}/images/solution-renders.webp`"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 2"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    Video fly-throughs
                  </div>
                  <div class="info-container__text">
                    Video clips complement the renderings, presenting
                    the apartment on any device from several angles.
                    All you need to create a video flight through the
                    interior is to adjust the viewing angle and speed
                    of the camera.
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container__video">
                    <video
                      no-controls
                      autoplay
                      loop
                      playsinline
                      muted
                    >
                      <source
                        :src="`${staticUrl}/video/video-fly.mp4`"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 3"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    3D-Tours for websites
                  </div>
                  <div class="info-container__text">
                    3D-tours are a tool that makes it possible to
                    virtually study the layout of an apartment and
                    present the interior from all sides.
                  </div>
                  <a
                    href="https://dreamflat.design/tours/Tour_from_09.03.2023_17-46-58-460/index.htm?n=2"
                    target="_blank"
                  >
                    <ui-button
                      color="primary"
                      class="button about-info-btn"
                      no-caps
                      label="Open"
                    />
                  </a>
                </div>
                <div class="video-container">
                  <div class="video-container__video" />
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 4"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    Interactive tours
                  </div>
                  <div class="info-container__text">
                    You can move around the apartment like in computer
                    game - using the keyboard or computer mouse.
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container">
                    <div class="video-container__video">
                      <video
                        no-controls
                        autoplay
                        loop
                        playsinline
                        muted
                      >
                        <source
                          :src="`${staticUrl}/video/interactive-tour.mp4`"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 5"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">VR</div>
                  <div class="info-container__text">
                    The DreamFlat VR mode allows you to move into an
                    apartment and, as if live, feel its dimensions,
                    the size of windows and the height of ceilings.
                    And high quality graphics will give you the
                    opportunity to evaluate the details of interior
                    design.
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container__image">
                    <img
                      :src="`${staticUrl}/images/mp-vr1.webp`"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="mobile-switcher">
          <div
            class="switcher-info-box"
            @touchstart="
              featuresCounter > 4
                ? (featuresCounter = 1)
                : (featuresCounter += 1)
            "
          >
            <transition name="switcher-animation" mode="out-in">
              <div
                v-if="featuresCounter === 1"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">Renders</div>
                  <div class="info-container__text">
                    Static renderers are an integral part of the
                    visualization of any project. DreamFlat allows you
                    to shoot photorealistic renderings in just a few
                    seconds!
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container__image">
                    <img
                      :src="`${staticUrl}/images/solution-renders.webp`"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 2"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    Video fly-throughs
                  </div>
                  <div class="info-container__text">
                    Video clips complement the renderings, presenting
                    the apartment on any device from several angles.
                    All you need to create a video flight through the
                    interior is to adjust the viewing angle and speed
                    of the camera.
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container__video">
                    <video
                      no-controls
                      autoplay
                      loop
                      playsinline
                      muted
                    >
                      <source
                        :src="`${staticUrl}/video/video-fly.mp4`"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 3"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    3D-Tours for websites
                  </div>
                  <div class="info-container__text">
                    3D-tours are a tool that makes it possible to
                    virtually study the layout of an apartment and
                    present the interior from all sides.
                  </div>
                  <a
                    href="https://dreamflat.design/tours/Tour_from_09.03.2023_17-46-58-460/index.htm?n=2"
                    target="_blank"
                  >
                    <ui-button
                      color="primary"
                      class="button about-info-btn"
                      no-caps
                      label="Open"
                    />
                  </a>
                </div>
                <div class="video-container">
                  <div class="video-container__video" />
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 4"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    Interactive tours
                  </div>
                  <div class="info-container__text">
                    You can move around the apartment like in computer
                    game - using the keyboard or computer mouse.
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container">
                    <div class="video-container__video">
                      <video
                        no-controls
                        autoplay
                        loop
                        playsinline
                        muted
                      >
                        <source
                          :src="`${staticUrl}/video/interactive-tour.mp4`"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 5"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">VR</div>
                  <div class="info-container__text">
                    The DreamFlat VR mode allows you to move into an
                    apartment and, as if live, feel its dimensions,
                    the size of windows and the height of ceilings.
                    And high quality graphics will give you the
                    opportunity to evaluate the details of interior
                    design.
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container__image">
                    <img
                      :src="`${staticUrl}/images/mp-vr1.webp`"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="switcher-info-box-elements-dots-box">
            <div
              class="dot"
              :class="{dot_active: featuresCounter === 1}"
              @click="featuresCounter = 1"
            />
            <div
              class="dot"
              :class="{dot_active: featuresCounter === 2}"
              @click="featuresCounter = 2"
            />
            <div
              class="dot"
              :class="{dot_active: featuresCounter === 3}"
              @click="featuresCounter = 3"
            />
            <div
              class="dot"
              :class="{dot_active: featuresCounter === 4}"
              @click="featuresCounter = 4"
            />
            <div
              class="dot"
              :class="{dot_active: featuresCounter === 5}"
              @click="featuresCounter = 5"
            />
          </div>
        </div>
      </section>
      <section class="people-section">
        <div class="people-section__wrp">
          <div class="info">
            <div class="title-box">
              <div class="title">For beginners.</div>
              <div class="title">For designers.</div>
              <div class="title">For you.</div>
              <p class="text">
                Whether it’s a home design, commercial project or
                client’s render, DreamFlat helps to bring your ideas
                to life.
              </p>
            </div>
            <div class="goahead">
              <DownloadLauncherButton
                icon="img:windows-icon.svg"
                :add-version-to-label="false"
              >
                <iconWindows />
              </DownloadLauncherButton>
            </div>
          </div>
          <div class="img__wrp">
            <img
              class="img__item-one"
              :src="`${staticUrl}/images/nmp-people.webp`"
              alt="people"
            />
          </div>
        </div>
      </section>
      <section class="were-help">
        <div class="were-help-header">
          <div class="were-help-header__title">
            We’re Here To Help
          </div>
          <div class="were-help-header__subtitle">
            From the first projects to the most demanding challenges,
            our free resources can help anyone achieve their goals
          </div>
        </div>
        <div class="were-help-cards">
          <div class="were-help-cards__item">
            <div class="were-help-cards__item-icon">
              <img
                src="../assets/new-main-page/nmp-Info.svg"
                alt=""
              />
            </div>
            <div class="were-help-cards__item-main">
              <div class="item-title">Learn DreamFlat</div>
              <div class="item-text">
                Manuals, tutorials & tips – all explained for you
              </div>
              <div class="item-button">
                <nuxt-link to="help-center"> Help Center </nuxt-link>
              </div>
            </div>
          </div>
          <div class="were-help-cards__item">
            <div class="were-help-cards__item-icon">
              <img
                src="../assets/new-main-page/nmp-Help_menu.svg"
                alt=""
              />
            </div>
            <div class="were-help-cards__item-main">
              <div class="item-title">FAQ</div>
              <div class="item-text">
                Answers to most common questions
              </div>
              <div class="item-button">
                <nuxt-link to="help-center?ref=faq"> FAQ </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="easy-steps-section">
        <div class="easy-info">
          <div class="easy-info-title">
            Three easy steps <br />
            <span class="easy-info-title__blue"
              >to visualize your ideas</span
            >
          </div>
          <div class="easy-info-desc">
            Don't wait any longer to turn your design dreams into
            reality
          </div>
          <div class="easy-info-sys">
            Windows 64-bit, RAM 12Gb, Modern Graphics Card.
            <nuxt-link
              to="help-center/about-dream-flat?article=installingRunning"
              class="easy-info-sys__link"
            >
              View system requirements
            </nuxt-link>
          </div>
          <div class="easy-info-download">
            <DownloadLauncherButton
              icon="img:windows-icon.svg"
              :add-version-to-label="false"
            >
              <iconWindows />
            </DownloadLauncherButton>
          </div>
        </div>
        <div class="easy-steps">
          <div class="easy-steps-cards">
            <div class="easy-steps-cards__num">1</div>
            <div class="easy-steps-cards__info">Download app</div>
          </div>
          <div class="easy-steps-cards">
            <div class="easy-steps-cards__num">2</div>
            <div class="easy-steps-cards__info">Create Layout</div>
          </div>
          <div class="easy-steps-cards">
            <div class="easy-steps-cards__num">3</div>
            <div class="easy-steps-cards__info">Enjoy</div>
          </div>
        </div>
      </section>
    </div>
    <VideoModal
      v-if="showVideoModal"
      :show="showVideoModal"
      :video="video"
      @hide="showVideoModal = false"
    />
  </div>
</template>
<script lang="ts" setup>
import {ref} from 'vue';
import DownloadLauncherButton from '../components/DownloadLauncherButton.vue';
import VideoModal from '../components/VideoModal.vue';
import iconPlay from '../assets/svg/play.svg';
import iconWindows from '~/assets/svg/windows-icon.svg';
import {useRuntimeConfig} from '#imports';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

const showVideoModal = ref(false);
const video = ref('promo');

function startVideo(source: string) {
  video.value = source;
  showVideoModal.value = true;
}
const featuresCounter = ref(1);
</script>
<style lang="scss">
.switcher-animation-enter-active,
.switcher-animation-leave-active {
  transition: opacity 0.1s ease-in-out;
}

.switcher-animation-enter-from,
.switcher-animation-leave-to {
  opacity: 0;
}

.goahead-btn {
  margin-left: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: $primary;
  cursor: pointer;
}

.head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
  .title {
    h1 {
      max-width: 460px;
      font-weight: 700;
      font-size: 36px;
      line-height: 120%;
      letter-spacing: 0.03em;
      color: $dark;
    }
    #hero-head-title {
      margin: 24px 0 !important;
    }
    .sub-title {
      font-size: 16px;
      color: #64686e;
      max-width: 460px;
    }

    .goahead {
      max-width: 460px;
      margin: 60px 0 74px 0;
      display: flex;
    }

    //  .goahead-btn {
    //   margin-left: 16px;
    //   display: flex;
    //   align-items: center;
    //   gap: 12px;
    //   color: $primary;
    //   cursor: pointer;
    //  }
  }

  .head-img-container {
    filter: drop-shadow(1px 1px 4px rgba(0, 0, 0, 0.5));
    width: 400px;
    height: 324px;
    cursor: pointer;

    .head-img {
      height: 324px;
      background-size: contain;
      position: relative;
      // left: -90px;
      mask-image: url('../assets/head-image-mask.svg');
      mask-size: contain;
      mask-repeat: no-repeat;
      // mask-position: 90px;
    }
  }

  .mobile-background-radial-image-block {
    display: none;
  }
}

.cards-head {
  display: flex;
  justify-content: flex-start;

  .item {
    margin-right: 24px;
    max-width: 220px;
    //width: 168px;
  }
  .custom-width {
    width: 168px;
  }

  .title {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 4px;
    letter-spacing: 0.03em;
    color: #3d424a;

    span {
      color: $primary;
    }
  }

  .text {
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: #3d424a;
  }
}

.m-btn {
  display: none;
}

.make-aesthetic-section {
  margin-top: 200px;
  .make-aesthetic-title-block {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &__title {
      font-size: 36px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: 1.08px;
      color: #3d424a;
      margin-bottom: 24px;
      text-align: center;
      .title_blue {
        color: $primary;
      }
      .mobile-indent {
        display: none;
      }
    }
    &__subtitle {
      font-weight: 400;
      font-size: 18px;
      text-align: center;
      color: #64686e;
    }
  }

  .make-aesthetic-cards-block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 23px;
    margin-top: 96px;
    &__card {
      height: 100%;
      background: #f6f8fd;
      border: 1px solid #e1e5f0;
      border-radius: 16px;
      padding: 16px;
      .ma-card-image {
        width: 100%;
      }
      .ma-card-title {
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        color: #3d424a;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        .ma-card-title-time {
          color: $primary;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
        }
      }
      .ma-card-subtitle {
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        letter-spacing: 0.03em;
        color: #3d424a;
      }
    }
    &__card_with-gap {
      margin-top: 24px;
    }
  }

  //.make-aesthetic-end-block {
  //  width: 100%;
  //  display: flex;
  //  flex-direction: column;
  //  align-items: center;
  //  &__icon {
  //    img {
  //      width: 48px;
  //    }
  //  }
  //  &__title {
  //    font-weight: 700;
  //    font-size: 36px;
  //    line-height: 44px;
  //    text-align: center;
  //    color: $primary;
  //  }
  //  &__black-title {
  //    font-weight: 700;
  //    font-size: 36px;
  //    line-height: 44px;
  //    text-align: center;
  //    color: #3D424A;
  //    margin-bottom: 24px;
  //  }
  //}
}

.landing-try {
  .info-section {
    display: flex;
    //justify-content: space-between;
    margin-top: 200px;
    margin-bottom: 00px;
    //margin: 192px auto;
    align-items: center;

    img {
      max-width: 484px;
    }
    .landing-try-image {
      width: 500px;
      margin-top: 16px;
    }

    .info {
      margin-left: 48px;

      .title {
        font-weight: 700;
        font-size: 36px;
        line-height: 120%;
        letter-spacing: 0.03em;
        margin-bottom: 24px;
        color: #3d424a;
      }

      .sub-title {
        width: 356px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #64686e;
      }

      .text {
        font-weight: 400;
        font-size: 14px;
        line-height: 140%;
        margin-bottom: 64px;
        letter-spacing: 0.02em;
        color: #64686e;
      }
    }

    .try-info {
      margin-left: 27px;
    }
  }
  .goahead-item {
    position: relative;
    display: inline-block;

    .goahead-item-after {
      //content: "attr(data-content)";
      position: absolute;
      text-align: center;
      top: -23px;
      width: 100%;
      left: 0;
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
      letter-spacing: 0.02em;
      color: #839aaf;
    }
  }
  .m-img {
    display: none;
  }
  @media (max-width: 600px) {
    .m-img {
      display: block;
      max-width: 100% !important;
      margin: 0 auto;
    }
    .m-btn {
      .landing-try-m-btn {
        width: 100% !important;
      }
    }
  }
}

.switcher-box {
  margin-top: 200px;
  &__title {
    font-weight: 700;
    font-size: 36px;
    line-height: 120%;
    color: #3d424a;
    margin-bottom: 96px;
    text-align: center;

    span {
      color: $primary;
    }
  }

  .switcher {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;

    &-chose-box {
      width: 50%;
      cursor: pointer;

      &__element {
        width: 110%;
        border-radius: 16px;
        background: #ffffff;
        padding: 24px;
        display: flex;
        gap: 16px;
        transition: background 0.3s ease-in-out;

        .el-number {
          width: 48px;
          height: 48px;
          border: 1.5px solid $primary;
          border-radius: 32px;

          background: #ffffff;

          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;

          color: $primary;

          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
        }

        .el-info {
          align-self: center;

          .el-title {
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            color: #3d424a;
          }

          .el-text {
            font-weight: 400;
            font-size: 16px;
            line-height: 140%;
            color: #839aaf;
          }
        }
      }

      .switcher-chose-box__element_active {
        background: #f6f8fd;

        .el-number {
          color: var(--var-white-100);
          background: $primary;
        }
      }
    }

    &-info-box {
      width: 50%;
      background: #f6f8fd;
      border-radius: 16px;
      cursor: default;

      &-child {
        width: 100%;
        height: 100%;
        padding: 24px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info-container {
          margin-bottom: 32px;

          &__title {
            font-weight: 700;
            font-size: 24px;
            line-height: 32px;
            color: #3d424a;
            margin-bottom: 8px;
          }

          &__text {
            font-weight: 400;
            font-size: 16px;
            line-height: 140%;
            color: #64686e;
          }

          a {
            display: block;
            margin-top: 24px;
          }
        }

        .video-container {
          &__image {
            width: 100%;

            img {
              width: 100%;
              border-radius: 8px;
            }
          }

          &__video {
            width: 100%;

            video {
              width: 100%;
              border-radius: 8px;
            }
          }
        }
      }
    }
  }

  .mobile-switcher {
    display: none;
  }
}

.people-section {
  margin-top: 200px;
  &__wrp {
    display: flex;
    justify-content: space-between;
    gap: 64px;
    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title-box {
        .title {
          font-weight: 700;
          font-size: 36px;
          line-height: 120%;
          letter-spacing: 0.03em;
          color: #3d424a;
        }
        .text {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          display: flex;
          align-items: center;
          letter-spacing: 0.02em;
          color: #64686e;
          margin-top: 24px;
        }
      }
    }
    .img__wrp {
      img {
        width: 500px;
      }
    }
    .goahead-mobile {
      display: none;
    }
  }
}

.were-help {
  margin-top: 200px;
  .were-help-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 96px;
    &__title {
      font-weight: 700;
      font-size: 36px;
      line-height: 120%;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.03em;
      color: #3d424a;
      margin-bottom: 8px;
    }
    &__subtitle {
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
      letter-spacing: 0.54px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #64686e;
      width: 50%;
    }
  }
  .were-help-cards {
    display: flex;
    justify-content: space-between;
    &__item {
      width: 45%;
      background: #f6f8fd;
      border: 1px solid #e1e5f0;
      border-radius: 16px;
      padding: 32px;
      display: flex;
      gap: 24px;
      // &-icon {

      // }
      &-main {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }
      .item-title {
        font-weight: 700;
        font-size: 36px;
        line-height: 120%;
        //text-align: center;
        letter-spacing: 0.03em;
        color: $primary;
      }
      .item-text {
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        //text-align: center;
        letter-spacing: 0.03em;
        color: #3d424a;
        margin-top: 16px;
      }
      .item-button {
        width: 50%;
        margin: 32px 0 0 0;
        a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          padding: 4px 32px;
          height: 40px;
          background: $primary;
          border-radius: 8px;
          font-weight: 600;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
  }
}

.steps-section {
  margin-top: 200px;
  .steps-title {
    .title {
      font-weight: 700;
      font-size: 36px;
      color: #3d424a;
      text-align: center;
      .title_blue {
        color: $primary;
      }
    }
  }
  .cards {
    display: flex;
    justify-content: space-between;
    margin-top: 128px;
    .item {
      width: 25%;
      .title {
        font-weight: 700;
        font-size: 24px;
        color: #3d424a;
        margin-bottom: 12px;
        margin-top: 48px;
      }
      .text {
        font-weight: 400;
        font-size: 14px;
        color: #64686e;
        span {
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          color: #b2c0cd;
        }
        a {
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          color: $primary;
        }
      }
    }
  }
}

.easy-steps-section {
  margin-top: 200px;
  margin-bottom: 100px;
  width: 100%;
  display: flex;
  gap: 24px;
  .easy-info {
    .easy-info-title {
      font-size: 36px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      color: #3d424a;
      letter-spacing: 1.08px;
      &__blue {
        color: $primary;
      }
    }
    .easy-info-desc {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 22.4px */
      letter-spacing: 0.48px;
      color: #64686e;
      margin-top: 24px;
    }
    .easy-info-sys {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.28px;
      color: #b2c0cd;
      a {
        color: $primary;
      }
    }
    .easy-info-download {
      margin-top: 64px;
    }
  }
  .easy-steps {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 50%;
    .easy-steps-cards {
      display: flex;
      width: 100%;
      padding: 16px;
      align-items: center;
      gap: 24px;
      border-radius: 12px;
      border: 1px solid #e1e5f0;
      background: #f6f8fd;
      &__info {
        color: #3d424a;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.72px;
      }
      &__num {
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.72px;
        color: #ffffff;
        width: 48px;
        height: 48px;
        border-radius: 32px;
        background: $primary;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

@media (max-width: 1024px) {
  .wrapper-for-adaptive {
    padding: 0 24px;
  }
  .were-help {
    .were-help-cards {
      &__item {
        .item-button {
          width: 80%;
        }
      }
    }
  }
}

@media (max-width: 800px) {
  .results-container {
    .results-cards-container {
      justify-content: center;
      .card {
        gap: 24px;
        padding: 16px;
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        text-align: center;
        .card-main {
          width: 100%;
          .card-footer {
            margin-top: 16px;
            a {
              width: 100% !important;
            }
            button {
              width: 100%;
            }
          }
        }
        .card-image {
          width: 100%;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .people-section {
    &__wrp {
      flex-direction: column;
      width: 100%;
      .img__wrp {
        img {
          width: 100%;
        }
      }
      .info {
        .goahead {
          display: none;
        }
      }
      .goahead-mobile {
        display: block;
        a {
          margin: 0;
          width: 100%;
        }
      }
    }
  }
  .landing-try {
    .info-section {
      flex-direction: column;
      margin: 81px auto 128px !important;
      padding-left: 5%;
      padding-right: 5%;

      img {
        display: none;
      }

      .card-image {
        img {
          display: block;
        }
      }

      .info {
        margin-left: 0 !important;
        width: 100% !important;

        .title {
          font-weight: 700;
          font-size: 24px !important;
          line-height: 32px !important;
        }

        .text {
          margin-top: 8px;
        }

        .m-btn {
          margin-top: 64px;
        }
      }

      .m-img {
        display: block;
        max-width: 80%;
        margin: 0 auto;
      }

      .goahead {
        display: none;
      }
    }
  }
  .were-help {
    &-header {
      &__subtitle {
        width: 100% !important;
      }
    }
  }
  .easy-steps-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    .easy-info {
      .easy-info-title {
        font-size: 24px;
      }
      .easy-info-desc {
        font-size: 15px;
      }
      .easy-info-download {
        margin-top: 48px;
      }
    }
    .easy-steps {
      width: 100%;
      gap: 24px;
      .easy-steps-cards {
        &__info {
          font-size: 16px;
        }
        &__num {
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          letter-spacing: 0.72px;
          color: #ffffff;
          width: 48px;
          height: 48px;
          border-radius: 32px;
          background: $primary;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

@media (max-width: 700px) {
  .hero {
    .head {
      margin-top: 16px;
      .head-img-container {
        //filter: drop-shadow(1px 1px 4px rgba(0, 0, 0, 0.5));
        //width: 400px;
        //height: 324px;
        //cursor: pointer;
        display: block !important;
        position: absolute;
        left: 0;
        z-index: -10;
        opacity: 25%;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        margin: 0 auto;
        filter: none;

        .head-img {
          //height: 324px;
          background-size: contain;
          position: relative;
          -webkit-mask-image: none;
          mask-image: none;
          height: 75vh !important;
          //height: 100vh!important;
          // left: -90px;
          //mask-image: url(assets/head-image-mask.svg);
          //mask-size: contain;
          //mask-repeat: no-repeat;
          // mask-position: 90px;
        }
      }
      .mobile-background-radial-image-block {
        display: block !important;
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        left: 0;
        top: -4%;
        overflow: hidden;
        svg {
          width: 100%;
        }
      }
      .title {
        #hero-head-title {
          font-size: 24px;
        }
        .sub-title {
          font-size: 15px;
        }
      }
      .goahead {
        display: none;
      }
    }
    .start-info-wrp {
      margin-top: 64px;
      .cards-head {
        display: flex;
        flex-wrap: wrap;
        .item {
          width: 100%;
          max-width: 700px;
          padding: 12px 16px;
          background: #ffffff;
          border: 1px solid #f4f6fd;
          border-radius: 8px;
          margin-right: 0;
          margin-top: 12px;
          .title {
            margin-top: 0;
            font-size: 18px;
          }
          .text {
            margin-bottom: 0;
            font-size: 15px;
          }
        }
      }
    }
    .m-btn {
      display: flex;
      margin-top: 64px;
      flex-wrap: wrap;
      gap: 16px;
      justify-content: center;
      button {
        width: 100% !important;
        border-radius: 8px;
        color: $primary;
      }
    }
  }
  .make-aesthetic-section {
    .make-aesthetic-title-block {
      &__title {
        font-size: 24px;
      }
      &__subtitle {
        font-size: 15px;
      }
    }
    .make-aesthetic-cards-block {
      margin-top: 64px;
      flex-wrap: wrap;
      &__card {
        .ma-card-title {
          font-size: 24px;
        }
        .ma-card-subtitle {
          font-size: 15px;
        }
      }
    }
    .make-aesthetic-end-block {
      &__title {
        font-size: 24px;
      }
      &__black-title {
        font-size: 24px;
      }
    }
  }
  .switcher-box {
    margin-top: 128px;

    &__title {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 40px;
    }

    .switcher {
      display: none;
    }

    .mobile-switcher {
      display: block;

      .switcher-info-box {
        width: 100%;
      }
      .switcher-info-box-elements-dots-box {
        display: flex;
        justify-content: center;
        width: 100%;
        gap: 8px;
        margin-top: 16px;
        .dot {
          width: 6px;
          height: 6px;
          background: #e1e5f0;
          border-radius: 100%;
        }
        .dot_active {
          background: $primary;
        }
      }
    }
  }
  .people-section {
    &__wrp {
      .info {
        .title-box {
          .title {
            font-size: 24px;
          }
          .text {
            font-size: 15px;
          }
        }
        .goahead {
          flex-wrap: wrap;
          button {
            width: 100%;
          }
          a {
            width: 100%;
            margin: 12px auto;
            border-radius: 8px;
            //border: 1px solid $primary;
            //background: $primary;
            //color: #FFFFFF!important;
          }
        }
      }
    }
  }
  .were-help {
    .were-help-header {
      margin-bottom: 64px;
      &__title {
        font-size: 24px;
      }
      &__subtitle {
        font-size: 15px;
        width: 100%;
      }
    }
    .were-help-cards {
      flex-wrap: wrap;
      gap: 24px;
      &__item {
        padding: 24px;
        width: 100%;
        .item-title {
          font-size: 24px;
        }
        .item-text {
          font-size: 15px;
        }
        .item-button {
          width: 100%;
        }
      }
    }
  }
  .steps-section {
    .steps-title {
      .title {
        font-size: 24px;
        line-height: 32px;
      }
    }
    .cards {
      flex-wrap: wrap;
      gap: 24px;
      margin-top: 64px;
      .item {
        width: 100%;
        text-align: center;
        .title {
          font-size: 24px;
          margin: 8px auto;
        }
      }
    }
  }
}
@media (max-width: 432px) {
  .make-aesthetic-section {
    .make-aesthetic-title-block {
      &__title {
        font-size: 24px;
        width: 100%;
        text-align: center;
        .mobile-indent {
          display: none;
        }
      }
      &__subtitle {
        font-size: 15px;
      }
    }
    .make-aesthetic-cards-block {
      margin-top: 64px;
      flex-wrap: wrap;
      &__card {
        .ma-card-title {
          font-size: 24px;
        }
        .ma-card-subtitle {
          font-size: 15px;
        }
      }
    }
    .make-aesthetic-end-block {
      &__title {
        font-size: 24px;
      }
      &__black-title {
        font-size: 24px;
      }
    }
  }
}
</style>
